<template>
  <div id="bar">
    <h3 class="p-3 text-white">出行城市排行</h3>
    <div id="city_rank"></div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts');
  // 引入饼状图
  require('echarts/lib/chart/pie');
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/legendScroll');

  export default {
    name: 'CityRank',
    data() {
      return {cityList: []}
    },
    computed: {
      ...mapState(['StoreChartLists']),
      cityRank() {
        return this.StoreChartLists.cityRank;
      },
    },
    watch: {
      'cityList': 'initEchart',
      cityRank(val) {
        this.cityList = [];
        val.map(item => {
          this.cityList.push({value: item.num, name: item.title})
        });
      },
    },
    methods: {
      /*初始化echart图表*/
      initEchart() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init($('#city_rank').get(0));
        let option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
             right: '40',
            bottom: 'center',
            data: this.cityList.map(item => item.name),
            textStyle: {
              color: 'white',
              fontSize: 15,
            }
          },
          series: [
            {
              name: '出行城市',
              type: 'pie',
              radius: '65%',
              center: ['40%', '50%'],
              selectedMode: 'single',
              data: this.cityList,
              label: {
                fontSize: 14,
                fontWeight:'bold',
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 12,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };
        // 绘制图表
        myChart.setOption(option)
      }
    }
  }
</script>

<style scoped lang="scss">
  #bar {
    background-color: #20283e;
    width: 100%;
  }

  #city_rank {
    width: 1000px;
    height: 600px;
    margin: 0 auto;
  }
</style>
